import config from './config';
import globals from './globals';
// import { config, globals } from '@/services';
// import $ from '../assets/scripts/jquery-3.6.0.min';
import Zlib from '../assets/scripts/zip.min';
// import Zlib from 'zlib';
import JSZip from '../assets/scripts/jszip.min';
import { router, ROUTES } from '@/router';
import * as CryptoJS from 'crypto-js';
import { isRef } from 'vue';

const $ = window.$;
var TScMessenger = window.TScMessenger;
// const ROUTES = {};
// methods
var formatNumberRgx = function (num) {

    var parts = num.toString().split(".");

    if (parts.length > 2) {
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join(".");
    } else {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
};

function setOptions(url, operationType, dataType, beforeSendFunction, apiVersion, asyncTransaction, timeout) {

    if (asyncTransaction === undefined) {
        asyncTransaction = true;
    }

    if (timeout === undefined) {
        timeout = (config.getRequestTimeout*1000);
    }

    var options = {
        url: config.getCloudServicesUrl() + apiVersion + '/' + url,
        type: operationType,
        crossDomain: true,
        dataType: dataType,
        beforeSend: beforeSendFunction,
        async: asyncTransaction,
        timeout: timeout,
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
    //     xhrFields: {
    //         withCredentials: true
    //    }
    };

    return options;

}

function setPostOptions(url, operationType, dataType, dataObj, beforeSendFunction, apiVersion, asyncTransaction, timeout, server) {

    let fullURL;
    
    if (asyncTransaction === undefined) {
        asyncTransaction = true;
    }

    if (timeout === undefined) {
        timeout = (config.postRequestTimeout*1000);
    }

    if(server === undefined) {
        server = config.SERVER.CLOUD_SERVICES;
    }

    if(server.Type === config.SERVER_TYPE.CLOUD_SERVICES) {
        fullURL = server.BaseURLFunc() + apiVersion + '/' + url;
    }else if(server.Type === config.SERVER_TYPE.AZURE_FUNCTIONS) {
        fullURL = server.BaseURLFunc() + '/api/' + url;
    }

    var options = {
        url: fullURL,
        type: operationType,
        crossDomain: true,
        dataType: dataType,
        data: dataObj,
        beforeSend: beforeSendFunction,
        async: asyncTransaction,
        timeout: timeout
    };

    return options;

}

function setOptionsCDNBaseURL(url, operationType, dataType, beforeSendFunction, asyncTransaction, timeout) {

    if (asyncTransaction === undefined) {
        asyncTransaction = true;
    }

    if (timeout === undefined) {
        timeout = (config.getRequestTimeout * 1000);
    }

    var options = {
        url: config.cdnAddress + url,
        type: operationType,
        crossDomain: true,
        dataType: dataType,
        beforeSend: beforeSendFunction,
        async: asyncTransaction,
        timeout: timeout,
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
    };

    return options;

}


function generateRoutesBasedOnPermissions(routes, permissions) {
    var returnArray = routes;

    returnArray.push(ROUTES.NOT_FOUND);
    returnArray.push(ROUTES.GET_STARTED);
    returnArray.push(ROUTES.SELECTION);
    
    returnArray.push(ROUTES.EXTERNAL_ACCESS);

    for (var prop in config.PERMISSIONS) {
        var permission = config.PERMISSIONS[prop];
        if ($.inArray(permission.Code, permissions) !== -1) {
            if (permission.Route) {
                returnArray.push(ROUTES[permission.Route]);
            }
        }
    }
    if ($.inArray(config.PERMISSIONS.SPECIFICATION.Code, permissions) === -1 && globals.user.allowSpecificationModule()) {
        returnArray.push(ROUTES[config.PERMISSIONS.SPECIFICATION.Route]);
    }
    returnArray.push(ROUTES.SUMMARY);

    return returnArray;
}

function generateRoutesBasedOnPermissionsAndDataAvailability(routes, permissions, dataAvailability) {
    var returnArray = routes;

    returnArray.push(ROUTES.NOT_FOUND);
    returnArray.push(ROUTES.GET_STARTED);
    returnArray.push(ROUTES.SELECTION);
    
    returnArray.push(ROUTES.EXTERNAL_ACCESS);

    for (var prop in config.PERMISSIONS) {
        var permission = config.PERMISSIONS[prop];
        if ($.inArray(permission.Code, permissions) !== -1) {
            if (permission.Route && (ROUTES[permission.Route].meta.dataAvailabilityCode === undefined || dataAvailability[ROUTES[permission.Route].meta.dataAvailabilityCode] === true)) {
                returnArray.push(ROUTES[permission.Route]);
            }
        }
    }
    if ($.inArray(config.PERMISSIONS.SPECIFICATION.Code, permissions) === -1 && globals.user.allowSpecificationModule() && dataAvailability.ActiveSpecification === true) {
        returnArray.push(ROUTES[config.PERMISSIONS.SPECIFICATION.Route]);
    }
    returnArray.push(ROUTES.SUMMARY);

    return returnArray;
}

function removeAllRoutes() {
    Object.keys(ROUTES).forEach(function (key) {
        if(router.hasRoute(ROUTES[key].name)) {
            router.removeRoute(ROUTES[key].name);
        }
    });
}

function addRoutes(routes) {
    routes.forEach(function (route) {
        router.addRoute(route);
    });
}

function getTurningMomentsFront(mass, distanceFromWheelbaseTheoreticalEnd, wheelbaseTheoretical) {
    if (wheelbaseTheoretical !== 0) {
        return (mass * distanceFromWheelbaseTheoreticalEnd) / wheelbaseTheoretical;
    } else {
        return 0;
    }
}

function getTurningMomentsFrontLeft(mass, distanceFromRightMostTrackWidthFront, trackWidthFront) {
    if (trackWidthFront !== 0) {
        return (mass * distanceFromRightMostTrackWidthFront) / trackWidthFront;
    } else {
        return 0;
    }
}

function getTurningMomentsLeft(mass, cogToEndOfTotalSpan, totalSpan) {
    if (totalSpan !== 0) {
        return (mass * cogToEndOfTotalSpan) / totalSpan;
    } else {
        return 0;
    }
}

function inheritsFrom(childObject, parentObject) {
    childObject = Object.create(parentObject.prototype);
}

function extend(base, sub) {
    // Avoid instantiating the base class just to setup inheritance
    // Also, do a recursive merge of two prototypes, so we don't overwrite 
    // the existing prototype, but still maintain the inheritance chain
    // Thanks to @ccnokes
    var origProto = sub.prototype;
    
    sub.prototype = Object.create(base.prototype);
    for (var key in origProto) {
        sub.prototype[key] = origProto[key];
    }
    // The constructor property was set wrong, let's fix it
    Object.defineProperty(sub.prototype, 'constructor', {
        enumerable: false,
        value: sub
    });

    //var origProto = sub.prototype;
    //sub.prototype = Object.create(base.prototype);
    //sub.prototype = jQuery.extend(sub.prototype, origProto);

    //// Remember the constructor property was set wrong, let's fix it
    //sub.prototype.constructor = sub;
    //// In ECMAScript5+ (all modern browsers), you can make the constructor property
    //// non-enumerable if you define it like this instead
    //Object.defineProperty(sub.prototype, 'constructor', {
    //    enumerable: false,
    //    value: sub
    //});
}
function convertRadiansToDegrees(radians) {
    return (radians * 180) / Math.PI;
}

function getAlias() {

    //determine the domain
    var domain = window.location.hostname.split('.');

    if (domain.length === 1 || domain.length === 3) {
        return domain[0];
    } else {

        var alias = '';

        for (var k = 0; k < domain.length - 2; k++) {
            if (k !== 0) {
                alias = alias + '.';
            }
            alias = alias + domain[k];
        }

        return alias;
    }
}

function isLegacyDomainAlias() {
    var alias = getAlias();
    var openingCharacters = alias.substring(0, 4).toLowerCase();
    if (openingCharacters === ("fuso")) {
        return true;
    }
    switch (alias) {
        case "app":
        case "appdev":
        case "apptest":
            return false;
        case "fuso-vietnam":
        case "fuso.vietnam":
        case "fuso.vietnam.dev":
        case "fuso.vietnam.test":
        case "fusovietnam":
        case "fusovietnamdev":
        case "fusovietnamtest":
        case "fusovn":
        case "fusovndev":
        case "fusovntest":
        case "fuso-vn":
        case "fuso-vndev":
        case "fuso-vntest":
        case "fuso-demo":
        case "fuso.demo":
        case "fuso.demo.test":
        case "fuso.demo.dev":
        case "fusodemo":
        case "fusodemotest":
        case "fusodemodev":
        case "volvo.southafrica":
        case "volvo.southafrica.test":
        case "volvo.southafrica.dev":
        case "volvosouthafrica":
        case "volvosouthafricatest":
        case "volvosouthafricadev":
        case "man.southafrica":
        case "man.southafrica.test":
        case "man.southafrica.dev":
        case "mansouthafrica":
        case "mansouthafricatest":
        case "mansouthafricadev":
        case "daf.southafrica":
        case "daf.southafrica.test":
        case "daf.southafrica.dev":
        case "dafsouthafrica":
        case "dafsouthafricatest":
        case "dafsouthafricadev":
        case "scania.southafrica":
        case "scania.southafrica.test":
        case "scania.southafrica.dev":
        case "scaniasouthafrica":
        case "scaniasouthafricatest":
        case "scaniasouthafricadev":
        case "isuzu.southafrica":
        case "isuzu.southafrica.test":
        case "isuzu.southafrica.dev":
        case "isuzusouthafrica":
        case "isuzusouthafricatest":
        case "isuzusouthafricadev":
        case "ud.southafrica":
        case "ud.southafrica.test":
        case "ud.southafrica.dev":
        case "udsouthafrica":
        case "udsouthafricatest":
        case "udsouthafricadev":
        case "hino.southafrica":
        case "hino.southafrica.test":
        case "hino.southafrica.dev":
        case "hinosouthafrica":
        case "hinosouthafricatest":
        case "hinosouthafricadev":
        case "mercedes-benz.southafrica":
        case "mercedes-benz.southafrica.test":
        case "mercedes-benz.southafrica.dev":
        case "mercedes-benzsouthafrica":
        case "mercedes-benzsouthafricatest":
        case "mercedes-benzsouthafricadev":
            return true;
        default:
            return false;
    }
}

function getOverwriteMessageText(objectType, optionalAccessoryType) {
    var messageText = config.getMessageText('1611', globals.getActiveCultureCodeForTranslations());
    var replacementText = '';
    if (objectType === config.OBJECT_TYPES.ACCESSORY) {
        replacementText = globals.getAccessoryTypeTranslation(optionalAccessoryType)
    } else if (objectType === config.CHASSIS_OBJECT_TYPES.VEHICLE) {
        replacementText = config.getTranslationText('4214');
    }
    messageText = messageText.replace('$S1', replacementText); // User Story 17565
    return messageText;
}

function returnValueOrZeroIfNanOrInfinity(valueToCheck) {

    if (!isNaN(parseFloat(valueToCheck)) && isFinite(valueToCheck)) {
        return valueToCheck;
    } else {
        return 0;
    }
}

function returnValueOrDashIfNanOrZero(valueToCheck) {

    if (!isNaN(parseFloat(valueToCheck)) && isFinite(valueToCheck) && valueToCheck !== 0) {
        return valueToCheck;
    } else {
        return config.defaultTableBlankRowChar;
    }
}

function getColour(blockName, cabColour) {
    if (blockName === 'CAB' && cabColour.colour !== undefined) {
        return parseInt(cabColour.colour.replace('#', '0x'), 16);
    } else {
        return parseInt(config.fillColour(blockName).replace('#','0x'),16);
    }
}



async function translateGraphicToXmlDoc(graphic) {
    if(graphic === null) {
        return null;
    }
    try {
        var xmlVar = "";

        // decode graphic from base64 encoding
        var decodedGraphic = window.atob(graphic);

        // convert string to UInt8Array
        var buf = new ArrayBuffer(decodedGraphic.length);
        var bufView = new Uint8Array(buf);
        for (var i = 0; i < decodedGraphic.length; i++) {
            bufView[i] = decodedGraphic.charCodeAt(i);
        }
        var bb = new Blob([buf]);
        bb.lastModifiedDate = new Date();
        bb.name = "archive.zip";
        // bb.type = "zip";

        // unzip the graphic file
        // var unzip = new Zlib.Unzip(bufView);
        // var filenames = unzip.getFilenames();
        // var plain = unzip.decompress(filenames[0]);

        var unzip = new JSZip();

        return await unzip.loadAsync(bb, {base64: false}).then(function(zip) {
            return zip.file("Graphic.xml").async("string").then(function (content) {
               // content is the file as a string
               if (window.ActiveXObject) {
                    var microsoftXML = new window.ActiveXObject("Microsoft.XMLDOM");
                    microsoftXML.loadXML(content);
                    // TScMessenger.writeDebugMessage(microsoftXML);
                    return microsoftXML;
                } else {
                    var otherXML = (new DOMParser()).parseFromString(content, "text/xml");
                    return otherXML;
                }
            });
        }).catch((e) => {
            var breakHere = 0;
        });

        // var img = zip.folder("images");
        // img.file("smile.gif", imgData, {base64: true});

        // unzip.files['tempFile'].async('blob').then(function(plain) {
        //     // see FileSaver.js
        //     // saveAs(content, "example.zip");
        //     for (var j = 0; j < plain.byteLength; j++) {
        //         xmlVar += String.fromCharCode(plain[j]);
        //     }
    
        //     if (window.ActiveXObject) {
        //         var microsoftXML = new window.ActiveXObject("Microsoft.XMLDOM");
        //         microsoftXML.loadXML(xmlVar);
        //         TScMessenger.writeDebugMessage(microsoftXML);
        //         return microsoftXML;
        //     } else {
        //         var otherXML = (new DOMParser()).parseFromString(xmlVar, "text/xml");
        //         return otherXML;
        //     }
        // }).catch(function (error){
        //     var breakHere = 0;

        // });
        
        
        
        // convert the Uint8Array back to string which contains graphics XML
        
    } catch (xmlUnzipEx) {
        return null;
    }

}

// function translateGraphicToXmlDoc(graphic) {
//     try {
//         var xmlVar = "";

//         // decode graphic from base64 encoding
//         var decodedGraphic = window.atob(graphic);

//         // convert string to UInt8Array
//         var buf = new ArrayBuffer(decodedGraphic.length);
//         var bufView = new Uint8Array(buf);
//         for (var i = 0; i < decodedGraphic.length; i++) {
//             bufView[i] = decodedGraphic.charCodeAt(i);
//         }

//         // unzip the graphic file
//         var unzip = new Zlib.Unzip(bufView);
//         var filenames = unzip.getFilenames();
//         var plain = unzip.decompress(filenames[0]);

//         // convert the Uint8Array back to string which contains graphics XML
//         for (var j = 0; j < plain.byteLength; j++) {
//             xmlVar += String.fromCharCode(plain[j]);
//         }

//         if (window.ActiveXObject) {
//             var microsoftXML = new window.ActiveXObject("Microsoft.XMLDOM");
//             microsoftXML.loadXML(xmlVar);
//             TScMessenger.writeDebugMessage(microsoftXML);
//             return microsoftXML;
//         } else {
//             var otherXML = (new DOMParser()).parseFromString(xmlVar, "text/xml");
//             return otherXML;
//         }
//     } catch (xmlUnzipEx) {
//         return null;
//     }

// }


async function translateXmlDocToGraphic(xmlDoc) {

    var xmlAsString = (new XMLSerializer()).serializeToString(xmlDoc);
    xmlAsString = xmlAsString.replace(/(\n)/gm, "\r\n");
    var buf = new ArrayBuffer(xmlAsString.length);
    var bufView = new Uint8Array(buf);
    for (var i = 0; i < xmlAsString.length; i++) {
        bufView[i] = xmlAsString.charCodeAt(i);
    }

    //var deflate = new Zlib.Deflate(bufView);
    //var compressed = deflate.compress();

    var zip = new JSZip();
    
    zip.file('Graphic.xml', bufView);
    return await zip.generateAsync({type : "uint8array"}).then(function (compressed){
        var graphicString = "";
        for (var j = 0; j < compressed.byteLength; j++) {
            graphicString += String.fromCharCode(compressed[j]);
        }
        var base64GraphicBlob = window.btoa(graphicString);
        return base64GraphicBlob;

    });

    
    
}


// function translateXmlDocToGraphic(xmlDoc) {

//     var xmlAsString = (new XMLSerializer()).serializeToString(xmlDoc);
//     xmlAsString = xmlAsString.replace(/(\n)/gm, "\r\n");
//     var buf = new ArrayBuffer(xmlAsString.length);
//     var bufView = new Uint8Array(buf);
//     for (var i = 0; i < xmlAsString.length; i++) {
//         bufView[i] = xmlAsString.charCodeAt(i);
//     }

//     //var deflate = new Zlib.Deflate(bufView);
//     //var compressed = deflate.compress();

//     var zip = new Zlib.Zip();
    
//     zip.addFile(bufView, {
//         filename: stringToByteArray('Graphic.xml')
//     });
//     var compressed = zip.compress();

//     var graphicString = "";
//     for (var j = 0; j < compressed.byteLength; j++) {
//         graphicString += String.fromCharCode(compressed[j]);
//     }
//     var base64GraphicBlob = window.btoa(graphicString);
//     return base64GraphicBlob;

//     function stringToByteArray(str) {
//         var array = new (window.Uint8Array !== void 0 ? Uint8Array : Array)(str.length);
//         var i;
//         var il;

//         for (i = 0, il = str.length; i < il; ++i) {
//             array[i] = str.charCodeAt(i) & 0xff;
//         }

//         return array;
//     }
// }

function clearSubscriptions(itemWithSubscriptions, dontClearChangeSubscriptions) {
    if (itemWithSubscriptions !== undefined && itemWithSubscriptions !== null) {
        if (!dontClearChangeSubscriptions) {
            try {
                while (itemWithSubscriptions._subscriptions && itemWithSubscriptions._subscriptions.change && itemWithSubscriptions._subscriptions.change.length > 0) {
                    itemWithSubscriptions._subscriptions.change.forEach(function (subscription) {
                        subscription.dispose();
                    });
                }
            } catch (changeSubscriptionsEx) {
                TScMessenger.writeDebugMessage("Error clearing subscriptions");
            }
        }
        try {
            while (itemWithSubscriptions._subscriptions && itemWithSubscriptions._subscriptions.beforeChange && itemWithSubscriptions._subscriptions.beforeChange.length > 0) {
                itemWithSubscriptions._subscriptions.beforeChange.forEach(function (subscription) {
                    subscription.dispose();
                });
            }
        } catch (beforeChangeSubscriptionsEx) {
            TScMessenger.writeDebugMessage("Error clearing beforeChange subscriptions");
        }
        try {
            while (itemWithSubscriptions._subscriptions && itemWithSubscriptions._subscriptions.arrayChange && itemWithSubscriptions._subscriptions.arrayChange.length > 0) {
                itemWithSubscriptions._subscriptions.arrayChange.forEach(function (subscription) {
                    subscription.dispose();
                });
            }
        } catch (arrayChangeSubscriptionsEx) {
            TScMessenger.writeDebugMessage("Error clearing arrayChange subscriptions");
        }
    }
}

function clearSubscriptionsWithoutDispose(itemWithSubscriptions, dontClearChangeSubscriptions) {
    if (itemWithSubscriptions !== undefined && itemWithSubscriptions !== null) {
        if (!dontClearChangeSubscriptions) {
            try {
                while (itemWithSubscriptions._subscriptions && itemWithSubscriptions._subscriptions.change && itemWithSubscriptions._subscriptions.change.length > 0) {
                    itemWithSubscriptions._subscriptions.change = [];
                }
            } catch (changeSubscriptionsEx) {
                TScMessenger.writeDebugMessage("Error clearing change subscriptions");
            }
        }
        try {
            while (itemWithSubscriptions._subscriptions && itemWithSubscriptions._subscriptions.beforeChange && itemWithSubscriptions._subscriptions.beforeChange.length > 0) {
                itemWithSubscriptions._subscriptions.beforeChange = [];
            }
        } catch (beforeChangeSubscriptionsEx) {
            TScMessenger.writeDebugMessage("Error clearing beforeChange subscriptions");
        }
        try {
            while (itemWithSubscriptions._subscriptions && itemWithSubscriptions._subscriptions.arrayChange && itemWithSubscriptions._subscriptions.arrayChange.length > 0) {
                itemWithSubscriptions._subscriptions.arrayChange = [];
            }
        } catch (arrayChangeSubscriptionsEx) {
            TScMessenger.writeDebugMessage("Error clearing arrayChange subscriptions");
        }
    }
}

function itemHasGraphic(item) {

    var graphicBlob, topViewGraphicBlob;

    if (item.getDecompressedGraphicBlob) {
        graphicBlob = item.getDecompressedGraphicBlob();
        topViewGraphicBlob = item.getDecompressedTopViewGraphicBlob();
    } else if (item.DecompressedGraphicBlob) {
        graphicBlob = item.DecompressedGraphicBlob;
        topViewGraphicBlob = item.DecompressedTopViewGraphicBlob;
    } else if (item.DecompressedGraphic) {
        graphicBlob = item.DecompressedGraphic;
        topViewGraphicBlob = item.DecompressedTopViewGraphicBlob;
    }


    if ((graphicBlob === null || graphicBlob === undefined || graphicBlob === '') && (topViewGraphicBlob === null || topViewGraphicBlob === undefined || topViewGraphicBlob === '')) {
        return false;
    } else {
        var xmlDoc = graphicBlob;
        if (xmlDoc === null || (xmlDoc.documentElement && xmlDoc.documentElement.childElementCount <= 1)) {
            xmlDoc = topViewGraphicBlob;
            if (xmlDoc === null || (xmlDoc.documentElement && xmlDoc.documentElement.childElementCount <= 1)) {
                return false;
            } else {
                return true;
            }
        } else {
            return true;
        }
    }

}


function itemHasSideViewGraphic(item) {
    //this method should only be used on the data retrieval side of things to check if there is a file/blob to decompress
    var sideViewGraphicBlob;

    if (item.getGraphicBlob) {
        sideViewGraphicBlob = item.getGraphicBlob();
    } else if(item.getVehicleDrawing) {
        sideViewGraphicBlob = item.getVehicleDrawing();
    } else if (item.GraphicBlob) {
        sideViewGraphicBlob = item.GraphicBlob;
    } else if (item.Graphic) {
        sideViewGraphicBlob = item.Graphic;
    }else if (item.VehicleDrawing) {
        sideViewGraphicBlob = item.VehicleDrawing;
    }


    if ((sideViewGraphicBlob === null || sideViewGraphicBlob === undefined || sideViewGraphicBlob === '')) {
        return false;
    } else {
        // var xmlDoc = translateGraphicToXmlDoc(sideViewGraphicBlob);
        // if (xmlDoc === null || (xmlDoc.documentElement && xmlDoc.documentElement.childElementCount <= 1)) {
        //     return false;
        // } else {
        //     return true;
        // }
        return true;
    }

}

function itemHasValidSideViewGraphic(item) {
    //this method is to help deal with the situation wherby the decompressed blob is not a valid xml graphic file, should be used everywhere except during data/item retrieval
    var sideViewGraphicBlob;

    if (item.getDecompressedGraphicBlob) {
        sideViewGraphicBlob = item.getDecompressedGraphicBlob();
    } else if(item.getDecompressedVehicleDrawing) {
        sideViewGraphicBlob = item.getDecompressedVehicleDrawing();
    } else if (item.DecompressedGraphicBlob) {
        sideViewGraphicBlob = item.DecompressedGraphicBlob;
    } else if (item.DecompressedGraphic) {
        sideViewGraphicBlob = item.DecompressedGraphic;
    }else if (item.DecompressedVehicleDrawing) {
        sideViewGraphicBlob = item.DecompressedVehicleDrawing;
    }


    if ((sideViewGraphicBlob === null || sideViewGraphicBlob === undefined || sideViewGraphicBlob === '')) {
        return false;
    } else {
        
        if (isValidDecompressedGraphicFile(sideViewGraphicBlob)) {
            return true;
        } else {
            return false;
        }
    }

}

function itemHasTopViewGraphic(item) {

    var topViewGraphicBlob;
    
    if (item.getTopViewGraphicBlob) {
        topViewGraphicBlob = item.getTopViewGraphicBlob();
    } else if (item.getVehicleTopViewDrawing) {
        topViewGraphicBlob = item.getVehicleTopViewDrawing();
    } else if (item.TopViewGraphicBlob) {
        topViewGraphicBlob = item.TopViewGraphicBlob;
    } else if (item.VehicleTopViewDrawing) {
        topViewGraphicBlob = item.VehicleTopViewDrawing;
    } 


    if (topViewGraphicBlob === null || topViewGraphicBlob === undefined || topViewGraphicBlob === '') {
        return false;
    } else {
        // var xmlDoc = topViewGraphicBlob;
        // if (xmlDoc === null || (xmlDoc.documentElement && xmlDoc.documentElement.childElementCount <= 1)) {
        //     return false;
        // } else {
        //     return true;
        // }
        return true;
    }

}

function itemHasValidTopViewGraphic(item) {

    var topViewGraphicBlob;
    
    if (item.getDecompressedTopViewGraphicBlob) {
        topViewGraphicBlob = item.getDecompressedTopViewGraphicBlob();
    } else if (item.getDecompressedVehicleTopViewDrawing) {
        topViewGraphicBlob = item.getDecompressedVehicleTopViewDrawing();
    } else if (item.DecompressedTopViewGraphicBlob) {
        topViewGraphicBlob = item.DecompressedTopViewGraphicBlob;
    } else if (item.DecompressedVehicleTopViewDrawing) {
        topViewGraphicBlob = item.DecompressedVehicleTopViewDrawing;
    } 


    if (topViewGraphicBlob === null || topViewGraphicBlob === undefined || topViewGraphicBlob === '') {
        return false;
    } else {
        if (isValidDecompressedGraphicFile(topViewGraphicBlob)) {
            return true;
        } else {
            return false;
        }
    }

}

function isValidDecompressedGraphicFile(xmlDoc) {
    return xmlDoc.documentElement && xmlDoc.documentElement.childElementCount > 1;
}

function getElevationFromItemConfigurationWizardStep(itemConfiguratioWizardStepType) {
    if (itemConfiguratioWizardStepType.indexOf(config.ELEVATION.TOP) !== -1) {
        return config.ELEVATION.TOP;
    } else if(itemConfiguratioWizardStepType.indexOf(config.ELEVATION.SIDE) !== -1) {
        return config.ELEVATION.SIDE;
    }
    return null;
}

function getModuleHashFromTitle(moduleTitle) {
    var foundHash = null;
    Object.keys(ROUTES).forEach(function (key) {
        if (ROUTES[key].meta.title === moduleTitle) {
            foundHash = ROUTES[key].meta.hash;
        }
    });

    return foundHash;
}


// function isTraversable(value) {
//     return value !== null && typeof value === 'object';
// }

// function hasSeen(value, visited) {
//     if (!isTraversable(value)) {
//         return false;
//     }
//     if (visited.has(value)) {
//         return true;
//     }
//     visited.add(value);
//     return false;
// }

// function deleteObjectMembers(obj, shallowOnly, visited) {
//     visited = visited || new WeakSet();

//     try {
//         if (!isTraversable(obj)) {
//             return;
//         }

//         if (isRef(obj)) {
//             const refValue = obj.value;

//             if (shallowOnly !== true && isTraversable(refValue) && !hasSeen(refValue, visited)) {
//                 deleteObjectMembers(refValue, false, visited);
//             }

//             obj.value = null;
//             return;
//         }

//         if (hasSeen(obj, visited)) {
//             return;
//         }

//         Object.keys(obj).forEach(function (member) {
//             const memberValue = obj[member];

//             if (memberValue && typeof memberValue.cleanUp === 'function') {
//                 memberValue.cleanUp();
//             }

//             if (shallowOnly !== true) {
//                 if (isRef(memberValue)) {
//                     const refValue = memberValue.value;

//                     if (isTraversable(refValue) && !hasSeen(refValue, visited)) {
//                         deleteObjectMembers(refValue, false, visited);
//                     }
//                 } else if (isTraversable(memberValue) && !hasSeen(memberValue, visited)) {
//                     deleteObjectMembers(memberValue, false, visited);
//                 }
//             }

//             if (isRef(memberValue)) {
//                 memberValue.value = null;
//             }

//             obj[member] = null;
//             delete obj[member];
//         });
//     } catch (error) {
//         let breakHere = 0;
//     }
// }

// function breakRefChains(obj, visited) {
//     visited = visited || new WeakSet();

//     try {
//         if (!isTraversable(obj) || hasSeen(obj, visited)) {
//             return;
//         }

//         if (isRef(obj)) {
//             const refValue = obj.value;
//             obj.value = null;

//             if (isTraversable(refValue) && !hasSeen(refValue, visited)) {
//                 breakRefChains(refValue, visited);
//             }
//             return;
//         }

//         Object.keys(obj).forEach(function (member) {
//             const memberValue = obj[member];

//             if (isRef(memberValue)) {
//                 const refValue = memberValue.value;
//                 memberValue.value = null;

//                 if (isTraversable(refValue) && !hasSeen(refValue, visited)) {
//                     breakRefChains(refValue, visited);
//                 }
//             } else if (isTraversable(memberValue) && !hasSeen(memberValue, visited)) {
//                 breakRefChains(memberValue, visited);
//             }
//         });
//     } catch (error) {
//         let breakHere = 0;
//     }
// }

// function cleanUpNuclearOption(obj, visited) {
//     visited = visited || new WeakSet();

//     try {
//         if (!isTraversable(obj)) {
//             return;
//         }

//         if (isRef(obj)) {
//             const refValue = obj.value;

//             if (isTraversable(refValue) && !hasSeen(refValue, visited)) {
//                 cleanUpNuclearOption(refValue, visited);
//                 deleteObjectMembers(refValue, true, visited);
//             }

//             obj.value = null;
//             return;
//         }

//         if (hasSeen(obj, visited)) {
//             return;
//         }

//         Object.keys(obj).forEach(function (member) {
//             const memberValue = obj[member];

//             if (isRef(memberValue)) {
//                 const refValue = memberValue.value;

//                 if (isTraversable(refValue) && !hasSeen(refValue, visited)) {
//                     cleanUpNuclearOption(refValue, visited);
//                     deleteObjectMembers(refValue, true, visited);
//                 }

//                 memberValue.value = null;
//             } else if (isTraversable(memberValue) && !hasSeen(memberValue, visited)) {
//                 cleanUpNuclearOption(memberValue, visited);
//                 deleteObjectMembers(memberValue, true, visited);
//             }

//             obj[member] = null;
//             delete obj[member];
//         });
//     } catch (error) {
//         let breakHere = 0;
//     }
// }

function flattenGraphIntoArray(obj, array) {

      try {
        if(obj !== null && (typeof obj === 'object' || Array.isArray(obj) || isRef(obj))) {
            for (var member in obj) {
                if((isRef(obj[member]) && typeof obj[member].value === 'object')) {
                    flattenGraphIntoArray(obj[member].value, array);
                } /*else if (typeof obj[member] === 'object' && obj[member] !== null) {
                    flattenGraphIntoArray(obj[member], array);
                }*/
                // if(isRef(obj[member])) {
                //     array.push(obj[member].value);
                // } else {
                //     array.push(obj[member]);
                // }
                
            } 
        }   
    } catch (error) {
        let breakHere = 0;    
    }
    if(isRef(obj)) {
        array.push(obj.value);
    } else {
        array.push(obj);
    }
    // array.push(obj);
}

function deleteObjectMembers(obj, shallowOnly, nullRefs) {
    try {
        if(obj !== null && (typeof obj === 'object' || Array.isArray(obj) || isRef(obj))) {
            for (var member in obj) {
                if (obj[member] && obj[member].cleanUp) {
                    obj[member].cleanUp();
                }
                if(shallowOnly !== true) {
                    if((isRef(obj[member]) && typeof obj[member].value === 'object')) {
                        deleteObjectMembers(obj[member].value, false);
                    } else if (typeof obj[member] === 'object' && obj[member] !== null) {
                        deleteObjectMembers(obj[member], false);
                    }
                }
                if(nullRefs === true) {
                    if(isRef(obj[member])) {
                        obj[member].value = null;
                    }
                }
                obj[member] = null;
                delete obj[member];
            } 
        }   
    } catch (error) {
        let breakHere = 0;    
    }
    obj = null;
}

function breakRefChains(obj) {
    try {
        for (var member in obj) {
            // if (obj[member] && obj[member].cleanUp) {
            //     obj[member].cleanUp();
            // }
            if(isRef(obj[member])) {
                if (typeof obj[member].value === 'object') {
                    breakRefChains(obj[member].value);
                }
            
                obj[member] = null;
            }
            // obj[member] = null;
            // delete obj[member];
        }    
    } catch (error) {
        let breakHere = 0;    
    }
    // obj = null;
}

function cleanUpNuclearOption(obj) {
    try {
        for (var member in obj) {
            // if (obj[member] && obj[member].cleanUp) {
            //     obj[member].cleanUp();
            // }
            if(isRef(obj[member])) {
                if (typeof obj[member].value === 'object') {
                    cleanUpNuclearOption(obj[member].value);
                    breakRefChains(obj[member].value);
                }
                deleteObjectMembers(obj[member].value, true);
                obj[member].value = null;
            } else if (typeof obj[member] === 'object' && obj[member] !== null) {
                cleanUpNuclearOption(obj[member]);
                deleteObjectMembers(obj[member], true);
            }
            obj[member] = null;
            delete obj[member];
        }    
    } catch (error) {
        let breakHere = 0;    
    }
    obj = null;
}



function isPlainObject(value) {
    if (value === null || typeof value !== 'object') {
        return false;
    }
    const proto = Object.getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
}

function describeNode(value) {
    if (value === null) {
        return 'null';
    }
    if (isRef(value)) {
        return 'ref';
    }
    if (Array.isArray(value)) {
        return 'array';
    }
    if (typeof value !== 'object') {
        return typeof value;
    }
    return value.constructor && value.constructor.name
        ? value.constructor.name
        : 'object';
}

function scanGraph(root, options) {
    const opts = options || {};
    const maxDepth = opts.maxDepth ?? 25;
    const maxNodes = opts.maxNodes ?? 10000;

    const seen = new WeakSet();
    const collected = [];
    const skipped = [];
    const stack = [{ value: root, path: 'root', depth: 0 }];
    let visitedCount = 0;

    while (stack.length > 0 && visitedCount < maxNodes) {
        const current = stack.pop();
        let value = current.value;
        let path = current.path;

        if (isRef(value)) {
            const refObject = value;

            if (!seen.has(refObject)) {
                seen.add(refObject);
                visitedCount++;
                collected.push({
                    path: path,
                    kind: 'ref',
                    value: refObject
                });
            }

            value = refObject.value;
            path = path + '.value';
        }

        if (value === null || typeof value !== 'object') {
            continue;
        }

        if (seen.has(value)) {
            continue;
        }
        seen.add(value);
        visitedCount++;

        if (Array.isArray(value)) {
            collected.push({
                path: path,
                kind: 'array',
                value: value
            });

            if (current.depth >= maxDepth) {
                continue;
            }

            for (let i = value.length - 1; i >= 0; i--) {
                stack.push({
                    value: value[i],
                    path: path + '[' + i + ']',
                    depth: current.depth + 1
                });
            }
            continue;
        }

        if (isPlainObject(value)) {
            collected.push({
                path: path,
                kind: 'plain-object',
                value: value
            });

            if (current.depth >= maxDepth) {
                continue;
            }

            const keys = Object.keys(value);
            for (let i = keys.length - 1; i >= 0; i--) {
                const key = keys[i];
                const child = value[key];

                if (child !== null && (typeof child === 'object' || isRef(child))) {
                    stack.push({
                        value: child,
                        path: path + '.' + key,
                        depth: current.depth + 1
                    });
                }
            }
            continue;
        }

        skipped.push({
            path: path,
            kind: 'non-plain-object',
            type: describeNode(value),
            value: value
        });
    }

    return {
        collected: collected,
        skipped: skipped,
        truncated: stack.length > 0,
        visitedCount: visitedCount
    };
}

// function runCollectedCleanup(scanResult) {
//     if (!scanResult || !Array.isArray(scanResult.collected)) {
//         return;
//     }

//     const items = scanResult.collected
//         .slice()
//         .sort(function (a, b) {
//             return b.path.length - a.path.length;
//         });

//     items.forEach(function (entry) {
//         const node = entry.value;

//         if (node == null) {
//             return;
//         }

//         try {
//             if (node && typeof node.cleanUp === 'function') {
//                 node.cleanUp();
//             } else if (node && typeof node.destroy === 'function') {
//                 node.destroy();
//             }
//         } catch (error) {
//             let breakHere = 0;
//         }

//         try {
//             if (entry.kind === 'ref') {
//                 node.value = null;
//                 return;
//             }

//             if (entry.kind === 'array') {
//                 for (let i = 0; i < node.length; i++) {
//                     node[i] = null;
//                 }
//                 node.length = 0;
//                 return;
//             }

//             if (entry.kind === 'plain-object') {
//                 Object.keys(node).forEach(function (key) {
//                     const child = node[key];

//                     if (child && typeof child.cleanUp === 'function') {
//                         try {
//                             child.cleanUp();
//                         } catch (error) {
//                             let breakHere = 0;
//                         }
//                     }

//                     if (isRef(child)) {
//                         child.value = null;
//                     }

//                     node[key] = null;
//                     delete node[key];
//                 });
//             }
//         } catch (error) {
//             let breakHere = 0;
//         }
//     });
// }

function runCollectedCleanup(scanResult, options) {
    const opts = options || {};
    const cleaned = opts.cleaned || new WeakSet();
    const skipNode = opts.skipNode;

    if (!scanResult || !Array.isArray(scanResult.collected)) {
        return cleaned;
    }

    const items = scanResult.collected
        .slice()
        .sort(function (a, b) {
            return b.path.length - a.path.length;
        });

    items.forEach(function (entry) {
        const node = entry.value;

        if (!node || typeof node !== 'object') {
            return;
        }

        if (node === skipNode || cleaned.has(node)) {
            return;
        }

        cleaned.add(node);

        if (typeof node.cleanUp === 'function') {
            node.cleanUp();
            return;
        }

        if (entry.kind === 'ref') {
            node.value = null;
            return;
        }

        if (entry.kind === 'array') {
            for (let i = 0; i < node.length; i++) {
                node[i] = null;
            }
            node.length = 0;
            return;
        }

        if (entry.kind === 'plain-object' && Object.keys(node) && Object.keys(node).length > 0) {
            Object.keys(node).forEach(function (key) {
                const child = node[key];
                if (isRef(child)) {
                    child.value = null;
                }
                node[key] = null;
                delete node[key];
            });
        }
    });

    return cleaned;
}

function encrypt(txt, optionalSecret) {
    return CryptoJS.AES.encrypt(txt, optionalSecret || globals.getStorageKey()).toString();
}

function decrypt(txtToDecrypt, optionalSecret) {
    return CryptoJS.AES.decrypt(txtToDecrypt, optionalSecret || globals.getStorageKey()).toString(CryptoJS.enc.Utf8);
}

function handleAppMessengerModeOverride(newAppMessengerMode) {
    if(newAppMessengerMode && (newAppMessengerMode === 'DEBUG' || newAppMessengerMode === 'TIMER')) {
        if(newAppMessengerMode === 'DEBUG') {
            TScMessenger.setMessengerModeToDebug();
        } else if(newAppMessengerMode === 'TIMER') {
            TScMessenger.setMessengerModeToTimer();
        }
        TScMessenger.setIntercomCallback(globals.getSendEventInfoToIntercomCallback());
    } else {
        TScMessenger.setIntercomCallback(null);
        TScMessenger.setMessengerMode(process.env.VUE_APP_DebugMode);
    }
}

function parseJwt (token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    
    return JSON.parse(jsonPayload);
    }


function bruteForceJQueryTeardown(rootElement) {
    if (rootElement && $ && typeof $.fn.multiselect === 'function') {    
        let multiSelects = $(rootElement).find('.multiselect-div');
        multiSelects.multiselect('destroy');

        $(rootElement).find('select').each(function() {
            if ($(this).data('multiselect')) {
                $(this).multiselect('destroy');
            }
        });

        $(rootElement)
            .find(".menu-message-link")
            .off("click touchstart");

        $(rootElement).find('.ui-slider, [data-slider]').each(function() {
            if ($(this).data('slider')) {
                $(this).slider('destroy');
            }
        });

        $(rootElement).find('*').off();
        $(rootElement).find('*').removeData();

        $(rootElement).off();
        $(rootElement).removeData();
        $(rootElement).empty();
    }
}

var utils = {
    formatNumberRgx: formatNumberRgx,
    setOptions: setOptions,
    setPostOptions: setPostOptions,
    generateRoutesBasedOnPermissions: generateRoutesBasedOnPermissions,
    generateRoutesBasedOnPermissionsAndDataAvailability: generateRoutesBasedOnPermissionsAndDataAvailability,
    getTurningMomentsFront: getTurningMomentsFront,
    inheritsFrom: inheritsFrom,
    extend: extend,
    convertRadiansToDegrees: convertRadiansToDegrees,
    isLegacyDomainAlias: isLegacyDomainAlias,
    getOverwriteMessageText: getOverwriteMessageText,
    returnValueOrZeroIfNanOrInfinity: returnValueOrZeroIfNanOrInfinity,
    setOptionsCDNBaseURL: setOptionsCDNBaseURL,
    getColour: getColour,
    translateGraphicToXmlDoc: translateGraphicToXmlDoc,
    clearSubscriptions: clearSubscriptions,
    clearSubscriptionsWithoutDispose: clearSubscriptionsWithoutDispose,
    itemHasGraphic: itemHasGraphic,
    getElevationFromItemConfigurationWizardStep: getElevationFromItemConfigurationWizardStep,
    translateXmlDocToGraphic: translateXmlDocToGraphic,
    itemHasSideViewGraphic: itemHasSideViewGraphic,
    itemHasTopViewGraphic: itemHasTopViewGraphic,
    getModuleHashFromTitle: getModuleHashFromTitle,
    deleteObjectMembers: deleteObjectMembers,
    removeAllRoutes: removeAllRoutes,
    addRoutes: addRoutes,
    isValidDecompressedGraphicFile: isValidDecompressedGraphicFile,
    itemHasValidSideViewGraphic: itemHasValidSideViewGraphic,
    itemHasValidTopViewGraphic: itemHasValidTopViewGraphic,
    returnValueOrDashIfNanOrZero: returnValueOrDashIfNanOrZero,
    encrypt: encrypt,
    decrypt: decrypt,
    handleAppMessengerModeOverride: handleAppMessengerModeOverride,
    getTurningMomentsLeft: getTurningMomentsLeft,
    parseJwt: parseJwt,
    cleanUpNuclearOption: cleanUpNuclearOption,
    breakRefChains: breakRefChains,
    flattenGraphIntoArray: flattenGraphIntoArray,
    scanGraph:scanGraph,
    runCollectedCleanup: runCollectedCleanup,
    bruteForceJQueryTeardown: bruteForceJQueryTeardown
};

export default utils;



